import { LeadFormResponseDialog } from '@/features/customers';
import { useResolvedRoutes } from '@/lib/use-routes';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/customers/$leadId/form'
)({ component: LeadFormRoute });
/** A linkable dialog; direct links still render the customer underneath. */
function LeadFormRoute() {
  const { leadId } = Route.useParams();
  const navigate = useNavigate();
  const routes = useResolvedRoutes();
  return (
    <LeadFormResponseDialog
      leadId={leadId}
      onClose={() => {
        void navigate({ to: routes.customerDetail(leadId), replace: true });
      }}
    />
  );
}
